import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Logo from '../../assets/img/logo/gemasan_logo.svg';
import footerBG from '../../assets/img/footer/footer-bg.jpg';

const Footer = (props) => {
  const { footerLogo, footerClass } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer>
      <div
        className={footerClass ? footerClass : 'footer__area footer__plr'}
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-1">
                <div className="footer__logo">
                  <Link to="/">
                    <img 
                      src={footerLogo ? footerLogo : Logo} 
                      alt="" 
                      style={{ filter: 'brightness(0) invert(1)' }}
                    />
                  </Link>
                </div>
                <div className="footer__content">
                  <div className="footer__text">
                    <p>
                      Denizcilik teknolojileri kapsamında gemiler için entegre sistemlerin geliştirilmesi ve taşımacılığı kolaylaştıracak yenilikçi çözümler üretiyoruz.
                    </p>
                  </div>
                  <div className="footer__number-wrapper">
                    <div className="footer__number-info">
                      <span>Sorularınız mı var?</span>
                      <a href="tel:+905313008336" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fal fa-phone-alt" style={{ color: '#ffffff' }}></i>
                        0 (531) 300 83 36
                      </a>
                      <a href="mailto:info@gemasan.com.tr" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}>
                        <i className="fal fa-envelope" style={{ color: '#ffffff' }}></i>
                        info@gemasan.com.tr
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-2">
                <h4 className="footer__title">
                  <a href="#" onClick={(e) => scrollToSection('cozumler', e)} style={{ cursor: 'pointer' }}>Hizmetlerimiz</a>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Su Altı Robotu</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Robot Kol</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Yapay Zeka Seyir Sistemi</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Kamera Sistemleri</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Yerli Alt Bileşen Üretimi</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-3">
                <h4 className="footer__title">
                  <a href="#" onClick={(e) => scrollToSection('robotik-kol', e)} style={{ cursor: 'pointer' }}>Ürünlerimiz</a>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <a href="#" onClick={(e) => scrollToSection('hakkimizda', e)} style={{ cursor: 'pointer' }}>Su Altı Robotu (ROV)</a>
                    </li>
                    <li>
                      <Link to="/robotkol" style={{ cursor: 'pointer' }}>Robot Kol</Link>
                    </li>
                    <li>
                      <Link to="/seyir" style={{ cursor: 'pointer' }}>Seyir Sistemi</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-4">
                <h4 className="footer__title">
                  <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Gemasan Bülteni</a>
                </h4>
                <div className="footer__content">
                  <p>
                    Denizcilik teknolojilerindeki son gelişmelerden haberdar olmak için bültenimize abone olun.
                  </p>
                </div>
                <div className="footer__input">
                  <form action="#">
                    <input type="email" placeholder="E-posta adresiniz" />
                    <button className="subscribe-btn" style={{ color: '#ffffff', backgroundColor: '#2a3658' }}>Abone Ol</button>
                  </form>
                </div>
                <div className="footer__social-box">
                  <span>Sosyal Medya:</span>
                  <a href="https://www.linkedin.com/company/trgemasan/?viewAsMember=true" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://www.instagram.com/trgemasan/" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://wa.me/905313008336" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright__area copyright__plr black-bg-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-md-4 wow animate__slideInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__text" style={{ textAlign: 'center' }}>
                <span>2025 Copyright Gemasan</span>
              </div>
            </div>
            <div
              className="col-md-4 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__item" style={{ textAlign: 'center' }}>
                <span>
                  <a href="#" onClick={(e) => scrollToSection('robotik-kol', e)} style={{ cursor: 'pointer' }}>Ürünlerimiz</a>
                </span>
                <span>
                  <a href="#" onClick={(e) => scrollToSection('hakkimizda', e)} style={{ cursor: 'pointer' }}>Hakkımızda</a>
                </span>
                <span>
                  <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>Gizlilik Politikası</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
